"use strict";

exports.__esModule = true;
exports.CalendarScreen = CalendarScreen;
var _react = _interopRequireWildcard(require("react"));
var _Core = require("../../Core");
var _Auth = require("../../Auth");
var _App = require("../../App");
var _CalendarToolbar = require("../CalendarToolbar");
var _CalendarEditor = require("../CalendarEditor/CalendarEditor");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function CalendarScreen() {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var _useState = (0, _react.useState)(undefined),
    deviceUUID = _useState[0],
    setDeviceUUID = _useState[1];
  return /*#__PURE__*/_react["default"].createElement(_Core.Screen, {
    title: translate("CalendarScreen.title", "Calendar"),
    "data-testid": "CalendarScreen"
  }, /*#__PURE__*/_react["default"].createElement(_App.AppNavbar, {
    title: translate("CalendarScreen.navbar.title", "Calendar")
  }), /*#__PURE__*/_react["default"].createElement(_CalendarToolbar.CalendarToolbar, {
    selectedDevice: deviceUUID,
    onSelectDevice: setDeviceUUID
  }), /*#__PURE__*/_react["default"].createElement(_Auth.AccessCheck, {
    permission: "EDIT_CALENDAR"
  }, function (_ref) {
    var isAllowed = _ref.isAllowed;
    return /*#__PURE__*/_react["default"].createElement(_CalendarEditor.CalendarEditor, {
      deviceUUID: deviceUUID,
      canEdit: isAllowed
    });
  }));
}